import type { RouteRecordRaw } from "vue-router";

export const onboardingRoutes: RouteRecordRaw[] = [
  {
    path: "/onboarding/edit",
    name: "onboarding-entry",
    component: () => import("./edit.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/onboarding/:step/edit",
    name: "onboarding-step",
    component: () => import("./step.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/re_onboarding",
    name: "re-onboarding",
    component: () => import("./re_onboarding.vue"),
    meta: {
      requiresAuth: true,
    },
  },
];
